<template>
  <div class="p-4 md:p-6 lg:p-8 xl:p-10 bg-app-bg-light dark:bg-app-bg-dark min-h-screen">
    <div class="mb-6 md:mb-8">
      <h1 class="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-800 dark:text-slate-100 mb-2">Panel de Inventarios</h1>
      <p class="text-sm md:text-base text-slate-600 dark:text-slate-400">Control de stock - {{ fechaActual }}</p>
    </div>

    <!-- Barra de actualización -->
    <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-5 shadow-sm mb-6 md:mb-8 flex items-center justify-between">
      <p class="text-sm text-slate-500 dark:text-slate-400">Los stocks se muestran en tiempo real</p>
      <button @click="cargarTodo"
        class="bg-custom-primary hover:opacity-90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-opacity border-0">
        <i class="bx bx-refresh mr-1"></i>Actualizar
      </button>
    </div>

    <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm mb-6 md:mb-8">
      <h2 class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6">Acciones Rápidas</h2>
      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        <button @click="$router.push('/inventario-general-hotel')" class="flex flex-col items-center p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0">
          <i class="bx bx-package text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"></i>
          <span class="text-sm text-slate-700 dark:text-slate-300">Inventario General</span>
        </button>
        <button @click="$router.push('/inventario-recepcion')" class="flex flex-col items-center p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0">
          <i class="bx bx-door-open text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"></i>
          <span class="text-sm text-slate-700 dark:text-slate-300">Recepción</span>
        </button>
        <button @click="$router.push('/inventario-lavanderia')" class="flex flex-col items-center p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0">
          <i class="bx bx-donate-heart text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"></i>
          <span class="text-sm text-slate-700 dark:text-slate-300">Lavandería</span>
        </button>
        <button @click="$router.push('/inventario-general-restaurante')" class="flex flex-col items-center p-4 rounded-lg bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 shadow-md hover:shadow-lg transition-all group border-0">
          <i class="bx bx-restaurant text-3xl text-custom-primary mb-2 group-hover:scale-110 transition-transform"></i>
          <span class="text-sm text-slate-700 dark:text-slate-300">Restaurante</span>
        </button>
      </div>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
      <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm">
        <div class="p-3 bg-red-100 dark:bg-red-900/30 rounded-lg w-fit mb-3">
          <i class="bx bx-error text-2xl text-red-600 dark:text-red-400"></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1">{{ stats.stockBajo }}</h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">Stock Bajo</p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm">
        <div class="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg w-fit mb-3">
          <i class="bx bx-package text-2xl text-blue-600 dark:text-blue-400"></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1">{{ stats.totalProductos }}</h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">Total Productos</p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm">
        <div class="p-3 bg-green-100 dark:bg-green-900/30 rounded-lg w-fit mb-3">
          <i class="bx bx-cart text-2xl text-green-600 dark:text-green-400"></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1">{{ stats.comprasHoy }}</h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">Compras Hoy</p>
      </div>
      <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm">
        <div class="p-3 bg-yellow-100 dark:bg-yellow-900/30 rounded-lg w-fit mb-3">
          <i class="bx bx-trending-down text-2xl text-yellow-600 dark:text-yellow-400"></i>
        </div>
        <h3 class="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-1">{{ stats.salidasHoy }}</h3>
        <p class="text-sm text-slate-600 dark:text-slate-400">Salidas Hoy</p>
      </div>
    </div>
    <div class="bg-white dark:bg-slate-800 rounded-xl p-4 md:p-6 shadow-sm mb-6 md:mb-8">
      <h2 class="text-xl font-semibold text-slate-800 dark:text-slate-100 mb-6">Productos con Stock Bajo</h2>
      <div v-if="productosStockBajo.length === 0" class="text-center text-slate-500 dark:text-slate-400 py-8">
        No hay productos con stock bajo
      </div>
      <div v-else class="space-y-3">
        <div v-for="(prod, i) in productosStockBajo" :key="i" class="flex items-center justify-between p-3 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700">
          <div>
            <p class="text-sm font-medium text-slate-800 dark:text-slate-100">{{ prod.nombre }}</p>
            <p class="text-xs text-slate-500 dark:text-slate-400">{{ prod.categoria }}</p>
          </div>
          <div class="text-right">
            <p class="text-sm font-bold text-red-600 dark:text-red-400">{{ prod.stock }} unidades</p>
            <p class="text-xs text-slate-500 dark:text-slate-400">Mín: {{ prod.minimo }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Alertas de inventario restaurante -->
    <div v-if="alertasRestaurante.length > 0" class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-4 md:p-6 shadow-sm mb-6">
      <h2 class="text-xl font-semibold text-red-800 dark:text-red-300 mb-4 flex items-center">
        <i class="bx bx-error-circle text-2xl mr-2"></i>
        Alertas Restaurante (Cocina/Barra)
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <div v-for="(alerta, i) in alertasRestaurante" :key="i" class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-red-300 dark:border-red-700">
          <p class="font-medium text-sm text-slate-800 dark:text-slate-100">{{ alerta.nombre }}</p>
          <div class="flex justify-between items-center mt-1">
            <span class="text-xs text-slate-600 dark:text-slate-400">{{ alerta.area }}</span>
            <span class="text-xs font-bold text-red-600 dark:text-red-400">
              Stock: {{ alerta.stock }} / {{ alerta.stock_minimo }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '../../config/config.js';

export default {
  name: 'DashboardInventarios',
  data() {
    return {
      loading: true,
      stats: { stockBajo: 0, totalProductos: 0, comprasHoy: 0, salidasHoy: 0 },
      productosStockBajo: [],
      alertasRestaurante: []
    };
  },
  computed: {
    fechaActual() {
      return new Date().toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    }
  },
  methods: {
    async cargarStats() {
      try {
        this.loading = true;
        const response = await axios.get(`${API_URL}/dashboard/inventarios`);

        this.stats.stockBajo = response.data.stockBajo || 0;
        this.stats.totalProductos = response.data.totalProductos || 0;
        this.stats.comprasHoy = response.data.comprasHoy || 0;
        this.stats.salidasHoy = response.data.salidasHoy || 0;

        this.loading = false;
      } catch (error) {
        console.error('Error cargando estadísticas:', error);
        this.loading = false;
      }
    },
    async cargarProductosStockBajo() {
      try {
        const response = await axios.get(`${API_URL}/dashboard/productos-stock-bajo`);
        this.productosStockBajo = response.data.map(item => ({
          nombre: item.Nombre,
          categoria: item.Categoria || 'Sin categoría',
          stock: item.Stock,
          minimo: item.StockMinimo
        }));
      } catch (error) {
        console.error('Error cargando productos stock bajo:', error);
      }
    },
    async cargarAlertasRestaurante() {
      try {
        const response = await axios.get(`${API_URL}/dashboard/alertas-inventario-restaurante`);
        this.alertasRestaurante = response.data || [];
      } catch (error) {
        console.error('Error cargando alertas restaurante:', error);
      }
    },
    cargarTodo() {
      this.cargarStats();
      this.cargarProductosStockBajo();
      this.cargarAlertasRestaurante();
    }
  },
  mounted() {
    this.cargarTodo();
  }
};
</script>
